// hydration.effects.ts
import { Injectable } from '@angular/core'
import { BaseHydrationEffects } from '@galabid/shared/hydration'
import { gbDebounceAfterFirst } from '@galabid/shared/utils/operators'
import { createEffect, ofType } from '@ngrx/effects'
import * as HydrationActions from 'libs/shared/hydration/src/lib/+state/base-hydration.actions'
import { switchMap, tap } from 'rxjs'
import { MaintenanceConstants } from 'libs/shared/maintenance/src/lib/maintenance.constants'

@Injectable()
export class DashboardHydrationEffects extends BaseHydrationEffects {
  SKIP_URL_PATHS = [MaintenanceConstants.UNDER_SCHEDULED_MAINTENANCE]

  CMS_URLS = [
    'localhost',
    'dev-dashboard.galabid.com',
    'staging-dashboard.galabid.com',
    'dashboard.galabid.com',
    'newdashboard-dev.galabid.com',
  ]

  serialize$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(HydrationActions.hydrateSuccess, HydrationActions.noStateHydration),
        switchMap(() => this.store),
        gbDebounceAfterFirst(1000),
        tap((state) => {
          if (this.pk && state) {
            this.preserveMostRecentStates()
            this.storage.setItem(this.pk, JSON.stringify(state))
            this.storage.setItem(`${this.pk}_updated`, new Date().toISOString())
          }
        }),
      ),
    { dispatch: false },
  )

  getLocalDBKey(): string {
    const host = window.location.hostname

    if (host && this.CMS_URLS.includes(host)) {
      const pathnameParts = window.location.pathname.trim().split('/')
      // Check if the pathname has a campaign url_name
      if (pathnameParts.length >= 2 && pathnameParts[1] === 'campaign') {
        return pathnameParts[2]
      }
    }

    return ''
  }
}
